<template>
  <div :class="['select-toggle-wrapper', customClasses]">
    <input-item :inputClass="selectBoxInput.class"
                :inputId="selectBoxInput.id"
                inputType="select"
                :inputValue="selectedValue"
                :labelText="selectBoxInput.labelText"
                :options="selectBoxInput.options"
                :shouldSetInteractions="shouldSetInteractions"
                :useCustomValidation="useCustomValidation"
                @customValidation="customValidation"
                @saveInputValue="saveSelect"
                @setInteractions="setInteractions"></input-item>

    <input-item v-show="shouldOpen"
                :inputClass="inputItem.class"
                :inputId="inputItem.id"
                :inputType="inputItem.inputType"
                :inputValue="inputItem.value"
                :labelText="inputItem.labelText"
                :showErrors="showErrors"
                :useCustomValidation="useCustomValidation"
                :zeroAllowed="zeroAllowed"
                @customValidation="customValidation"
                @saveInputValue="saveInput"
                @setErrors="setInputErrors"
                @setInteractions="setInteractions"></input-item>
  </div>
</template>


<script>
  import InputItem from './InputItem'

  export default {
    props: {
      customClasses: String,
      inputItem: Object,
      openToggleValue: [Number, String],
      selectBoxInput: Object,
      shouldSetInteractions: Boolean,
      showErrors: Boolean,
      useCustomValidation: Boolean,
      zeroAllowed: Boolean,
    },

    name: 'SelectToggle',

    components: {
      InputItem,
    },

    data() {
      return {
        selectedValue: null,
      }
    },

    methods: {
      customValidation($target) {
        this.$emit('customValidation', $target, this.inputItem.id)
      },

      setInputErrors(errorKey, errorMessage) {
        this.$emit('setErrors', this.inputItem.id, errorMessage)
      },

      setInteractions(item) {
        if (this.shouldSetInteractions) { this.$emit('setInteractions', item) }
      },

      saveInput(dataToSave) {
        this.$emit('saveInputValue', dataToSave)
      },

      saveSelect(dataToSave) {
        this.selectedValue = dataToSave[this.selectBoxInput.id]
        this.$emit('saveInputValue', dataToSave)
        if (!this.shouldOpen) { return this.$emit('setErrors', this.inputItem.id, null) }
      },
    },

    created() {
      this.selectedValue = this.selectBoxInput.value
    },

    computed: {
      shouldOpen: function() {
        // https://softwareengineering.stackexchange.com/questions/268124/does-using-in-javascript-ever-make-sense
        // not best practice, but it's because we are comparing strings & numbers
        return this.selectedValue == this.openToggleValue
      },
    },
  }
</script>
